interface RightArrowIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export default function RightArrowIcon(props: RightArrowIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={31.504}
      height={30.705}
      viewBox="0 0 31.504 30.705"
      className="icon"
      {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        data-name="Icon awesome-arrow-right"
        d="M13.395 2.053L14.956.492a1.681 1.681 0 012.384 0l13.668 13.661a1.681 1.681 0 010 2.384L17.339 30.21a1.681 1.681 0 01-2.384 0l-1.56-1.557a1.689 1.689 0 01.028-2.412l8.477-8.075H1.688A1.683 1.683 0 010 16.478v-2.25a1.683 1.683 0 011.688-1.687H21.9l-8.477-8.072a1.677 1.677 0 01-.028-2.416z"
      />
    </svg>
  )
}
